var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1190,
    height: 1432,
    viewBox: "55 80 1190 1432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Legs / 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.551 1366.69L640.117 1317.8L577.348 1286.04L568.239 1425.82H785.704C748.703 1383.96 639.551 1366.69 639.551 1366.69ZM387.097 1368.6L387.661 1313.68L327.481 1355.93L317.83 1365.56L302.944 1425.82H451.784C433.071 1374.63 387.097 1368.6 387.097 1368.6Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Legs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.686 1313.68L330.919 1294.73L317.828 1365.56L387.097 1368.6L393.686 1313.68ZM640.117 1317.8L577.348 1298.85L572.29 1363.65L639.551 1366.69L640.117 1317.8Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pants"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pants_2",
    d: "M454.14 1290.62H463.993L457.968 1347.12H292.007L298.031 1290.62H309.012L432.583 366.001L510.22 366.001L699.051 366L683.37 1291.63H691.834V1346.11H525.875V1291.63H535.266L525.873 944.492L454.14 1290.62Z",
    fill: "#2F2F3D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    opacity: 0.200358,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.094 976.583L592.245 528.935L529.364 1105.88L523.094 976.583Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.b626c8a5.svg";
export { ForwardRef as ReactComponent };